// File: frontend/src/components/Settings/SecuritySettings.jsx
// Security settings component

import SystemSettings from './SystemSettings';

const SecuritySettings = () => {
  return (
    <div className="p-6">
      <div className="mb-6">
        <h3 className="text-lg font-medium text-gray-900 mb-2">Configuraciones de Seguridad</h3>
        <p className="text-sm text-gray-500">
          Gestiona las políticas de seguridad y contraseñas del sistema.
        </p>
      </div>
      
      <SystemSettings filter="security" />
      
      <div className="mt-8 p-4 bg-blue-50 rounded-lg">
        <h4 className="text-sm font-medium text-blue-800">Información de Seguridad</h4>
        <p className="mt-1 text-sm text-blue-700">
          Las configuraciones de seguridad afectan a todos los usuarios del sistema. 
          Cambia estas configuraciones con precaución.
        </p>
      </div>
    </div>
  );
};

export default SecuritySettings;